import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Details } from "../../services/user.services";

export default function UserDetails() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userId) {
      Details(userId)
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => {
          console.error("Error fetching transaction:", err);
        })
        .finally(() => setLoading(false));
    }
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (!user) return <div>User not found.</div>;

  return (
    <div className="main-content">
      <div className="Transactions-part">
        <div className="card-box">
          <div className="row">
            <div className="col-md-4">
              <p className="text-color">Name</p>
              <p className="subtitle-1 ps-3">{user.fullName || user.name || user.email || "N/A"}</p>
              <p className="text-color">Email</p>
              <p className="subtitle-1 ps-3">{user.email || "N/A"}</p>
              <p className="text-color">Phone</p>
              <p className="subtitle-1 ps-3">{user?.phone_number?.fullNumber || user?.phone_number?.phone || "N/A"}</p>
            </div>
            {/* <div className="col-md-3">
              <p className="text-color">Customer Name</p>
              <p className="subtitle-1 ps-3">{transaction.user.name || "N/A"}</p>
              <p className="text-color">Amount</p>
              <p className="subtitle-1 ps-3">
                {transaction.currency} {transaction.}
              </p>
              <p className="text-color">Status</p>
              <p className="subtitle-1 ps-3 pt-0">{transaction.status}</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
